<template>
  <FormModal
    v-if="data"
    title="Edit Site Custom Translation"
    method="PUT"
    :endpoint="`partners/${partner_id}/sites/${site_id}/custom-translations/${custom_translation_id}`"
    :data="data"
    v-bind="$attrs"
    size="wide"
    @success="success"
  >
    <InputGroup label="Language" name="translation_id">
      <pre class="py-3 px-6 text-sm">{{ data.language.icon }} {{ data.language.name }}</pre>
    </InputGroup>

    <InputGroup label="Translation Key" name="translation_key_id">
      <pre class="py-3 px-6 text-sm">{{ data.key }}</pre>
    </InputGroup>

    <InputGroup label="(Default) English Value" name="current_english_value" v-if="data.default_english_value">
      <pre class="py-3 px-6 text-sm">{{ data.default_english_value }}</pre>
    </InputGroup>

    <InputGroup label="(Default) Translated Value" name="current_english_value" v-if="data.default_translation_value">
      <pre class="py-3 px-6 text-sm">{{ data.default_translation_value }}</pre>
    </InputGroup>

    <InputGroup label="Value" name="value">
      <TextInput v-model="data.value" textarea :rows="3" />
    </InputGroup>
  </FormModal>
</template>

<script>
export default {
  props: {
    partner_id: {
      type: Number,
      required: true
    },
    site_id: {
      type: Number,
      required: true
    },
    custom_translation_id: {
      type: Number,
      required: true
    }
  },
  async mounted() {
    const response = await this.$api.get(
      `partners/${this.partner_id}/sites/${this.site_id}/custom-translations/${this.custom_translation_id}`
    )
    this.data = response.data?.data ?? {}
  },
  data: () => ({
    data: {}
  }),
  methods: {
    success() {
      this.$notification.success(`Custom translation successfully updated.`)
      this.$emit("close")
    }
  }
}
</script>
